import React from 'react';

import { useGridSlotComponentProps } from '@mui/x-data-grid';

import { CustomArrowPagination } from './CustomArrowPagination';
import { CustomPagination } from './CustomPagination';

// Passed via `componentsProps.pagination` when the grid's own pageSize/rowCount
// include synthetic rows (e.g. a totals row) that must not show in the "x - y of z" label.
interface PaginationOverrides {
  pageSize?: number;
  rowCount?: number;
}

export const GridCustomPagination = (overrides: PaginationOverrides) => {
  const {
    state: { pagination },
    options,
  } = useGridSlotComponentProps();

  const setPage = (newPage: number) => {
    options?.onPageChange?.(newPage);
  };

  return <CustomPagination {...pagination} {...overrides} setPage={setPage} />;
};

export const GridArrowCustomPagination = (overrides: PaginationOverrides) => {
  const {
    state: { pagination },
    options,
  } = useGridSlotComponentProps();
  const setPage = (newPage: number) => {
    options?.onPageChange?.(newPage);
  };

  return <CustomArrowPagination {...pagination} {...overrides} setPage={setPage} />;
};
